import InnovationByDesignPage from './innovation_by_design_page';
import innovationByDesignPageStateManager from './innovation_by_design_page_state_manager';

export default function(store) {
  return {
    path: '/innovation-by-design/:year/category/:category',
    component: InnovationByDesignPage,
    exact: true,
    strict: true,
    loadData: innovationByDesignPageStateManager(store),
    autoScrollOff: true
  };
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/ibd/innovation_by_design_page/ibd_category_route.js